var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserContactAdd(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9334 11.5333C13.7334 11.5333 15.1334 10.0667 15.1334 8.26668C15.1334 6.46668 13.6667 5.06668 11.8667 5.06668C10.0667 5.06668 8.66669 6.53335 8.66669 8.26668C8.66669 10.0667 10.1334 11.5333 11.9334 11.5333ZM11.8667 6.40001C11.9334 6.40001 11.9334 6.40001 11.8667 6.40001C12.9334 6.40001 13.8 7.26668 13.8 8.33335C13.8 9.40001 12.9334 10.2 11.8667 10.2C10.8 10.2 10 9.33335 10 8.33335C10 7.26668 10.8667 6.40001 11.8667 6.40001V6.40001Z",
    fill: "#0285CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4 15.1333L17.2667 14.9333C15.9334 13.4667 14.0667 12.6 12.0667 12.6667C10.0667 12.6 8.13335 13.4667 6.80002 14.9333L6.66669 15.1333V20.2C6.66669 20.8 7.13335 21.3333 7.80002 21.3333H16.3334C16.9334 21.3333 17.4667 20.8 17.4667 20.2V15.1333H17.4ZM16.0667 20H8.00002V15.6C9.06669 14.5333 10.5334 14 12.0667 14C13.5334 13.9333 15 14.5333 16.0667 15.6V20Z",
    fill: "#0285CD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 8V15",
    stroke: "#0285CD",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 11.5H9",
    stroke: "#0285CD",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserContactAdd);
export default __webpack_public_path__ + "static/media/user-contact-add.fbe153ec54bf5a00574d7734e802faaa.svg";
export { ForwardRef as ReactComponent };